import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
export var TaskLabel = function TaskLabel(_ref) {
  var label = _ref.label,
    isAira = _ref.isAira,
    labelClassName = _ref.labelClassName;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 px-1.5 py-1 rounded min-w-0 max-w-full ".concat(!isAira ? "bg-[#00d0cd29]" : ""),
    style: isAira ? {
      backgroundImage: "linear-gradient(92deg, rgba(255, 120, 105, 0.25) -67.38%, rgba(232, 132, 130, 0.25) -18.48%, rgba(201, 149, 164, 0.25) 36.54%, rgba(152, 174, 217, 0.25) 91.56%)"
    } : {}
  }, isAira && /*#__PURE__*/React.createElement("img", {
    src: "/assets/icons/aira-logo.svg",
    alt: "AIRA",
    className: "w-[15px] h-[15px]"
  }), /*#__PURE__*/React.createElement("span", {
    title: label,
    className: classNames("text-[12px] font-semibold uppercase tracking-[0.16px] text-gray-600 dark:text-gray-400 truncate", labelClassName)
  }, label));
};